var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 20 20",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0.833984C4.94004 0.833984 0.833374 4.94065 0.833374 10.0007C0.833374 15.0607 4.94004 19.1673 10 19.1673C15.06 19.1673 19.1667 15.0607 19.1667 10.0007C19.1667 4.94065 15.06 0.833984 10 0.833984ZM2.66671 10.0007C2.66671 5.94898 5.94837 2.66732 10 2.66732C11.6959 2.66732 13.2542 3.24482 14.4917 4.21648L4.21587 14.4923C3.24421 13.2548 2.66671 11.6965 2.66671 10.0007ZM10 17.334C8.30421 17.334 6.74587 16.7565 5.50837 15.7848L15.7842 5.50898C16.7559 6.74648 17.3334 8.30482 17.3334 10.0007C17.3334 14.0523 14.0517 17.334 10 17.334Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.69418eefef418206bf5f28261cbf598b.svg";
export { ForwardRef as ReactComponent };